<div class="main d-flex flex-column">
    <div class="nec-tabs">
        <button *ngFor="let tab of tabs" [class.selected]="selectedTab === tab.id" (click)="switchTab(tab.id)">
            <span>{{ tab.name }}</span>
            <div class="num-of-instatiations" [class.selected]="selectedTab === tab.id">
                {{ tab.count }}
            </div>
        </button>
    </div>
    <div class="filters d-flex align-items-center gap-3">
        <div class="filter-button-container">
            <button class="d-flex gap-3 align-items-center" (click)="filterOpened = !filterOpened">
                <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2 3.75H14M6 14.25H10M4 9H12" stroke="#171717" stroke-width="1.5" stroke-linecap="round" />
                </svg>
                <span>Filter</span>
            </button>
            <div *ngIf="filterOpened" class="filters-window">
                <lib-nec-filter [regions]="geoRegions" [allAreas]="allSubGeoRegions"
                    [substationTemplates]="substationTemplateOptions" [filter]="filter"
                    (applyFilter)="onFilterApplied()"></lib-nec-filter>
            </div>
        </div>
        <div class="search-filter d-flex align-items-center">
            <div class="search-type d-flex gap-2 align-items-center"
                (click)="searchDropdownOpened = !searchDropdownOpened">
                <span>{{ getSearchTypeLabel() }}</span>
                <img height="12" width="12" src="../../../../assets/icons/arrow-down-small.svg" />
            </div>
            <div class="search-bar">
                <img height="16" width="16" src="assets/icons/search.svg" alt="Search icon" />
                <input type="text" placeholder="Search" [(ngModel)]="filter.searchValue"
                    (keydown.enter)="getAllAcLineSegments()" />
            </div>
            <div *ngIf="searchDropdownOpened" class="search-dropdown">
                <ul>
                    <li (click)="selectSearchType(AcLineSearchType.Name)">Asset Name</li>
                    <li (click)="selectSearchType(AcLineSearchType.Number)">Asset Number</li>
                    <li (click)="selectSearchType(AcLineSearchType.SubstationName)">Substation Name</li>
                </ul>
            </div>
        </div>
    </div>

    <div class="table-container">
        <table>
            <thead>
                <tr *ngIf="selectedTab != AcLineSegmentType.Incomer">
                    <th class="d-flex align-items-center gap-3">
                        <input class="checkbox" type="checkbox" />
                        <span>Name</span>
                    </th>
                    <th>Number</th>
                    <th *ngIf="hasBands">Band</th>
                    <th>Electrical address</th>
                    <th>Substation Type</th>
                    <th>Substation Name</th>
                    <th>Region</th>
                    <th></th>
                </tr>
                <tr *ngIf="selectedTab == AcLineSegmentType.Incomer">
                    <th class="d-flex align-items-center gap-3">
                        <input class="checkbox" type="checkbox" />
                        <span>Name</span>
                    </th>
                    <th>Base Voltage</th>
                    <th>Parent Class (Substation)</th>
                    <th>Asset Name</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let acLineSegment of acLineSegments">
                    <td>
                        <div class="cell-content">
                            <input class="checkbox" type="checkbox" />
                            <span class="span-padding">{{ acLineSegment.name | hasValue }}</span>
                        </div>
                    </td>
                    <ng-container *ngIf="selectedTab != AcLineSegmentType.Incomer">
                        <td>
                            <div class="cell-content">
                                <span class="span-padding">{{ acLineSegment.number | hasValue }}</span>
                            </div>
                        </td>
                        <td *ngIf="hasBands">
                            <div class="cell-content">
                                <span class="span-padding">{{ acLineSegment.feederBand | hasValue}}</span>
                            </div>
                        </td>
                        <td>
                            <div class="cell-content">
                                <span class="span-padding">{{ acLineSegment.electricalAddress | hasValue }}</span>
                            </div>
                        </td>
                        <td>
                            <div class="cell-content">
                                <span class="span-padding">{{ acLineSegment.substationType | hasValue }}</span>
                            </div>
                        </td>
                        <td>
                            <div class="cell-content">
                                <span class="span-padding">{{ acLineSegment.substationName | hasValue }}</span>
                            </div>
                        </td>
                        <td>
                            <div class="cell-content">
                                <span class="span-padding">{{ acLineSegment.region | hasValue}}</span>
                            </div>
                        </td>

                    </ng-container>
                    <ng-container *ngIf="selectedTab == AcLineSegmentType.Incomer">
                        <td>
                            <div class="cell-content">
                                <span class="span-padding">{{ acLineSegment.baseVoltage | hasValue }}</span>
                            </div>
                        </td>
                        <td>
                            <div class="cell-content">
                                <span class="span-padding">{{ acLineSegment.substationType | hasValue }}</span>
                            </div>
                        </td>
                        <td>
                            <div class="cell-content">
                                <span class="span-padding">{{ acLineSegment.substationName | hasValue }}</span>
                            </div>
                        </td>
                    </ng-container>

                    <td class="menu-cell">
                        <div *ngIf="permissionsService.isNetworkEntityClassesCreateEditAllowed || permissionsService.isNetworkEntityClassesDeleteAllowed || selectedTab !== AcLineSegmentType.Incomer"
                            class="menu-wrapper cell-content dots-padding">
                            <div class="dots" (click)="toggleMenu(acLineSegment, $event)">
                                <svg width="22" height="22" viewBox="0 0 22 22" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M3.43647 7.16337L6.15006 9.19769C6.76771 9.6607 7.65378 9.4528 8.00108 8.76344C8.16304 8.44191 8.45676 8.20667 8.80589 8.11883L10.3201 7.73791C11.3039 7.49041 12.0717 6.72137 12.3173 5.7371L13.0568 2.77495M3.43647 7.16337C2.8501 8.31607 2.51953 9.62073 2.51953 11.0026C2.51953 15.6855 6.31579 19.4818 10.9987 19.4818C15.6816 19.4818 19.4779 15.6855 19.4779 11.0026C19.4779 7.02949 16.7452 3.69461 13.0568 2.77495M3.43647 7.16337C4.8372 4.4098 7.69766 2.52344 10.9987 2.52344C11.7085 2.52344 12.3979 2.61065 13.0568 2.77495"
                                        stroke="#171717" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path
                                        d="M12.9051 15.5843C13.4236 15.5843 13.8975 15.2915 14.1294 14.8277C14.4373 14.2121 14.2399 13.4635 13.6685 13.0795L12.5205 12.3081C12.157 12.0638 11.7351 11.9204 11.2979 11.8925L10.6919 11.8539C10.3692 11.8332 10.0531 11.9522 9.82404 12.1805C9.44262 12.5605 9.38294 13.1572 9.68168 13.6052L10.2932 14.5225C10.7355 15.1859 11.48 15.5843 12.2773 15.5843H12.9051Z"
                                        stroke="#171717" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                            </div>
                            <div class="popup-menu" libPopupMenuFlip *ngIf="actionMenuOpenForId === acLineSegment.id">
                                <button
                                    *ngIf="selectedTab != AcLineSegmentType.Incomer && permissionsService.isNetworkEntityClassesCreateEditAllowed"
                                    class="menu-item" (click)="selectAcLineSegment(acLineSegment.id)"
                                    data-bs-toggle="modal" data-bs-target="#editAddModal-1">
                                    Update
                                </button>
                                <button
                                    *ngIf="selectedTab == AcLineSegmentType.Incomer && permissionsService.isNetworkEntityClassesCreateEditAllowed"
                                    class="menu-item" (click)="selectIncomerAcLineSegment(acLineSegment.id)"
                                    data-bs-toggle="modal" data-bs-target="#editAddModal-3">
                                    Update
                                </button>
                                <button class="menu-item" *ngIf="selectedTab !== AcLineSegmentType.Incomer"
                                    (click)="openSchematicDiagram(acLineSegment.id)">
                                    Schema
                                </button>
                                <button class="menu-item"
                                    (click)="viewHistory(acLineSegment.id!)"
                                    data-bs-toggle="modal" data-bs-target="#acLineHistory">
                                    History
                                </button>
                            </div>
                        </div>
                    </td>

                </tr>
            </tbody>
        </table>
    </div>


    <div class="bv-pagination py-4">
        <lib-pagination-new [totalItems]="count" [pageSize]="pageSize" [currentPage]="currentPage"
            [pageSizes]="pageSizes" (pageChange)="onPageChange($event)" (pageSizeChange)="onPageSizeChange($event)">
        </lib-pagination-new>
    </div>
</div>

<lib-nec-add-edit-modal-ac-line-segment *ngIf="selectedTab != AcLineSegmentType.Incomer" [hidden]="!modalOpened"
    [selectedAcLineSegmentId]="selectedAcLineSegmentId" [substationTemplateOptions]="substationTemplateOptions"
    (acLineSegmentSaved)="reloadTable()" [isBoundary]="selectedTab == AcLineSegmentType.Boundary"
    [boundaryId]="boundaryId" [module]="acLineModule">
</lib-nec-add-edit-modal-ac-line-segment>

<lib-nec-add-edit-modal-connector-switch [isOpenedFromSubstation]="false"
    [selectedEquipmentId]="selectedAcLineSegmentId" (equipmentSaved)="reloadTable()" [hidden]="!incomerModalOpened"
    [entityName]="'Incomer'" [selectedEquipmentType]="{ value: 'AcLineSegment', name: 'Incomer' }">
</lib-nec-add-edit-modal-connector-switch>

<lib-nec-upload-modal-power-transformer [hidden]="!uploadModalOpened" [uploadType]="UploadFileType" [module]="acLineModule">
</lib-nec-upload-modal-power-transformer>

<lib-nec-ac-line-schematic *ngIf="schematicModalOpened" [acLineId]="selectedAcLineForSchematic"
    (close)="closeSchematicDiagram()"></lib-nec-ac-line-schematic>

<div class="modal fade" id="acLineHistory" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered ac-line-history-modal">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Update History</h5>
                <button type="button" class="btn-cancel-modal" data-bs-dismiss="modal" aria-label="Close">
                    Cancel
                </button>
            </div>
            <div class="modal-body ac-line-history-body">
                <table class="ac-line-history-table">
                    <thead>
                        <tr class="header-row">
                            <th>Timestamp</th>
                            <th>Changed By</th>
                            <th>Email</th>
                            <th>Role</th>
                            <th>Name <span class="sub-header">Prev / New</span></th>
                            <th>Number <span class="sub-header">Prev / New</span></th>
                            <th>Band <span class="sub-header">Prev / New</span></th>
                            <th>Customer Type <span class="sub-header">Prev / New</span></th>
                            <th>Parent Substation <span class="sub-header">Prev / New</span></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="content-wrapper" *ngFor="let item of acLineHistoryItems">
                            <td>{{ item.timestamp | date : "dd/MM/yyyy HH:mm:ss" | hasValue }}</td>
                            <td>{{ item.user | hasValue }}</td>
                            <td>{{ item.userEmail | hasValue }}</td>
                            <td>{{ item.userRole | hasValue }}</td>
                            <td>
                                <ng-container *ngIf="item.previousName != null || item.newName != null; else nameNc">
                                    <span class="prev-value">{{ item.previousName }}</span>
                                    <span class="new-value">{{ item.newName }}</span>
                                </ng-container>
                                <ng-template #nameNc><span class="not-changed">Not changed</span></ng-template>
                            </td>
                            <td>
                                <ng-container *ngIf="item.previousNumber != null || item.newNumber != null; else numberNc">
                                    <span class="prev-value">{{ item.previousNumber }}</span>
                                    <span class="new-value">{{ item.newNumber }}</span>
                                </ng-container>
                                <ng-template #numberNc><span class="not-changed">Not changed</span></ng-template>
                            </td>
                            <td>
                                <ng-container *ngIf="item.previousBand != null || item.newBand != null; else bandNc">
                                    <span class="prev-value">{{ item.previousBand }}</span>
                                    <span class="new-value">{{ item.newBand }}</span>
                                </ng-container>
                                <ng-template #bandNc><span class="not-changed">Not changed</span></ng-template>
                            </td>
                            <td>
                                <ng-container *ngIf="item.previousCustomerType != null || item.newCustomerType != null; else customerTypeNc">
                                    <span class="prev-value">{{ item.previousCustomerType }}</span>
                                    <span class="new-value">{{ item.newCustomerType }}</span>
                                </ng-container>
                                <ng-template #customerTypeNc><span class="not-changed">Not changed</span></ng-template>
                            </td>
                            <td>
                                <ng-container *ngIf="item.previousParentSubstation != null || item.newParentSubstation != null; else substationNc">
                                    <span class="prev-value">{{ item.previousParentSubstation }}</span>
                                    <span class="new-value">{{ item.newParentSubstation }}</span>
                                </ng-container>
                                <ng-template #substationNc><span class="not-changed">Not changed</span></ng-template>
                            </td>
                        </tr>
                        <tr *ngIf="acLineHistoryItems.length === 0">
                            <td class="no-history" colspan="9">No history available</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>